import * as React from 'react';

import Grid from '@mui/material/Grid2';
import { WorkshopInfoPanel } from './WorkshopInfoPanel';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

export interface PageSectionProps {
    heading?: string;
    workshopInfoPanel?: typeof WorkshopInfoPanel;
    subheading?: string;
    divider?: boolean,
    children?: React.ReactNode[];
    columnSpacing?: number
}

export const PageSection = ({heading, subheading, divider, children, columnSpacing}: React.PropsWithChildren<PageSectionProps>) => {
    const workshopInfoPanelType = React.createElement(WorkshopInfoPanel).type;    
    const childrenArray = React.Children.toArray(children);
    let childWidth = 6 / (childrenArray.length - 1);

    if(typeof (childrenArray.find(child => React.isValidElement(child) && child.type === workshopInfoPanelType)) === "undefined")
        childWidth = 12 / (childrenArray.length);

    const childrenContainer =
        <Grid container size={12} columnSpacing={columnSpacing ?? 30}>
            {childrenArray.map(child => {
                if (React.isValidElement(child) && child.type === workshopInfoPanelType)
                    return <Grid container size={6}>{child}</Grid>;
                else
                    return <Grid height="100%" size={childWidth}>{child}</Grid>
            })
        }
        </Grid>

    return (
        <Box mt={16} pb={30} pt={20}  borderTop={divider?.5:undefined}>
            <Typography variant="h5">{heading}</Typography>
            <Grid container size={12} pt={20}>
                {childrenContainer}
            </Grid>
        </Box>
    )
}